import React from 'react';
import Combokeys from 'combokeys';
import PausePlugin from 'combokeys/plugins/pause';
import BindGlobal from 'combokeys/plugins/global-bind';

const shortcutManager = new Combokeys(window.top?.document);

BindGlobal(shortcutManager);
// Putting this after BindGlobal, so we are able to pause global shortcuts
PausePlugin(shortcutManager);

export default function useKeyShortcut(key: string, handler: Function | undefined, dependencies: any[] = [], bindGlobal = false) {
    React.useEffect(() => {
        if (typeof handler !== 'function') {
            return;
        }

        const handleKeyDown = event => {
            event.preventDefault();
            event.stopPropagation();
            handler(event);
        };
        if (bindGlobal) {
            shortcutManager.bindGlobal(key, handleKeyDown);
        } else {
            shortcutManager.bind(key, handleKeyDown);
        }

        return () => {
            shortcutManager.unbind(key);
        };
    }, [key, ...dependencies]);
}

export const useDisableKeyShortcuts = () => {
    React.useEffect(() => {
        shortcutManager.pause();

        return shortcutManager.unpause;
    }, []);
};

export const useShortcutsToggle = (disable: boolean) => {
    React.useEffect(() => {
        if (disable) {
            shortcutManager.pause();
        } else {
            shortcutManager.unpause();
        }
    }, [disable]);
};

export const useShortcutsToggleFunction = () => {
    return [shortcutManager.pause, shortcutManager.unpause];
};
